import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
/* eslint-disable react/no-danger,@typescript-eslint/naming-convention */
import { useController, useFormContext, } from 'react-hook-form';
import { useCallback } from 'preact/compat';
import DOMPurify from 'dompurify';
import { Signature } from '@widgets/shared/components/Signature';
import Styles from '@widgets/shared/styles/modal';
import { DummyLink } from '@genericBookings/components/SelectedOption/styles';
function TermsModal({ termsHeading, termsSubheading, termsContent, onConfirm, onCancel, name, termsShowCheckbox, showSignatureField = false, }) {
    const stopProp = (ev) => {
        ev.stopImmediatePropagation();
    };
    const { control, watch, setValue, resetField, clearErrors, setError, } = useFormContext();
    const { field: { value } } = useController({
        name: name,
        control,
    });
    const termsAccepted = Boolean(watch(name));
    const signature = watch('SignatureName');
    const handleCloseClicked = useCallback(async (ev) => {
        resetField('SignatureName');
        return onCancel(ev);
    }, [onCancel, resetField]);
    const handleConfirmClicked = useCallback(async (ev) => {
        clearErrors('SignatureName');
        if (!showSignatureField || (showSignatureField && signature && signature.length)) {
            return onConfirm(ev);
        }
        setError('SignatureName', {
            type: 'manual',
            message: 'Please enter your name',
        });
        return false;
    }, [
        clearErrors,
        onConfirm,
        setError,
        showSignatureField,
        signature,
    ]);
    return (_jsx(Styles.Backdrop, { onClick: handleCloseClicked, children: _jsxs(Styles.Inner, { onClick: stopProp, children: [_jsx(Styles.Close, { className: "close", type: "button", onClick: handleCloseClicked, title: "Close Modal", children: _jsx("svg", { children: _jsx("use", { xlinkHref: "#icon--tooltip-close" }) }) }), _jsxs(Styles.Header, { children: [_jsx(Styles.Heading, { children: termsHeading }), _jsx(Styles.SubHeading, { children: termsSubheading })] }), _jsx(Styles.Content, { className: "terms", children: _jsx("div", { dangerouslySetInnerHTML: { __html: DOMPurify.sanitize(termsContent) } }) }), showSignatureField && (_jsx(Signature, { onConfirm: handleConfirmClicked, agreedTerms: DOMPurify.sanitize(termsContent) })), termsShowCheckbox && (_jsxs(Styles.Controls, { children: [_jsx("div", { className: "form__group", children: _jsxs("div", { className: "checkbox", children: [_jsx("input", { type: "checkbox", id: "terms-and-conditions", value: value, name: name, className: "form__control checkbox__input", checked: termsAccepted, onChange: () => setValue(name, !termsAccepted) }), _jsx("label", { htmlFor: "terms-and-conditions", className: "form__label checkbox__label", children: "I have read and accept the terms & conditions" })] }) }), _jsxs("div", { className: "form__actions", children: [_jsx("button", { type: "button", id: "terms-button", disabled: !termsAccepted, className: "btn btn--secondary", onClick: handleConfirmClicked, children: "Proceed" }), _jsx(DummyLink, { onClick: handleCloseClicked, children: "Go back" })] })] }))] }) }));
}
export default TermsModal;
